import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { toast } from "react-toastify";

import { useRouter } from "components/hooks";
import { get } from "utils/request";

import { getMagnetDetailURL } from "apis/magnets";
import { getBrandPublicProfile } from "apis/brand";

import Loading from "components/atoms/Loading";
import { useQuery } from "@tanstack/react-query";
import MagnetPublicProfile from "./MagnetPublicProfile";
import { ROUTES, TOAST_CONFIG } from "../../constants";

function MagnetPage({ setIsSidebarCustomized }: { setIsSidebarCustomized: Dispatch<SetStateAction<boolean>> }) {
  // const [magnetDetails, setMagnetDetails] = useState();
  const [brandWithMagnet, setBrandWithMagnet] = useState<BrandWithMagnets | null>(null);
  const router = useRouter();

  const { brandId, magnetId }: { brandId: string; magnetId: string } = router.query;

  function handleGetMagnetFailure(errorMessage: string, error: any) {
    toast.error(errorMessage, TOAST_CONFIG);
    if (error.response.status === 404) {
      router.go(`/${ROUTES.NOT_FOUND}`);
      return;
    }
    throw new Error(errorMessage);
  }

  const getMagnetDetails = () =>
    get(getMagnetDetailURL(magnetId), {
      processError: handleGetMagnetFailure,
    });

  const {
    isLoading: isMagnetDetailsLoading,
    error: magnetDetailsError,
    data: magnetDetails,
    isRefetching: isMagnetDetailsRefetching,
    refetch: refetchMagnetDetails,
  } = useQuery({
    queryKey: [magnetId],
    queryFn: getMagnetDetails,
  });

  // Get Brand With Magnets
  async function getBrandDetailsAndMagnetList() {
    try {
      if (!brandId) {
        return;
      }
      const brandDetailsFromAPI = await get(getBrandPublicProfile(brandId));
      if (brandDetailsFromAPI === null) {
        toast.error("Failed to fetch brand details.", TOAST_CONFIG);
      } else {
        setBrandWithMagnet(brandDetailsFromAPI);
      }
    } catch (err) {
      toast.error("Failed to fetch brand details", TOAST_CONFIG);
    }
  }

  useEffect(() => {
    getBrandDetailsAndMagnetList();
  }, [brandId, magnetId]);

  if (magnetDetailsError && !magnetDetails) {
    return null;
  }
  return !isMagnetDetailsLoading && brandWithMagnet ? (
    <MagnetPublicProfile
      setIsSidebarCustomized={setIsSidebarCustomized}
      refetchMagnetDetails={refetchMagnetDetails}
      isMagnetDetailsRefetching={isMagnetDetailsRefetching}
      magnetDetails={magnetDetails}
      brandWithMagnet={brandWithMagnet}
    />
  ) : (
    <Loading />
  );
}
export default MagnetPage;
